
<template>
  <div class="pageComplaintsSuggestions">
    <XR-head titleText="投诉建议" :rightShow="false"></XR-head>
    <mu-list v-if="!loaded" v-for="data in dataList" :key="data.Id">
      <template v-if="!data.ReplyContent">
        <mu-list-item :title="data.MessageType==1?'【投诉】'+data.Title:'【建议】'+data.Title" :afterText="data.CreateDateName">
          <span slot="describe">
            {{data.Content}}
          </span>
        </mu-list-item>    
      </template>      
      <template v-if="data.ReplyContent">
        <mu-list-item :title="data.MessageType==1?'【投诉】'+data.Title:'【建议】'+data.Title" @click="openPopup(data.ReplyContent)">
          <span slot="describe">
            {{data.Content}}
          </span>
          <mu-icon slot="right" value=":fa fa-msg" style="color:#ccc"></mu-icon>         
        </mu-list-item>
      </template>      
    </mu-list>
      
    <mu-float-button icon=":fa fa-plus" @click="open" class="btn-cs-add" style="z-index:200" primary />
    <mu-dialog :open="dialog" @close="close" title="请选择" scrollable>
      <mu-menu>
        <mu-menu-item title="投诉" @click="goTo('/usercenter/ComplaintsSuggestionsAdd?bz=1')" />
        <mu-menu-item title="建议" @click="goTo('/usercenter/ComplaintsSuggestionsAdd?bz=0')"/>
      </mu-menu>
      <mu-flat-button primary label="关闭" @click="close" slot="actions"/>
    </mu-dialog>

    <mu-popup position="bottom" popupClass="pageComplaintsSuggestions-popup" :open="Popup" @close="closePopup()">
      <mu-content-block>
        <p class="title">
          您有新的回复!
        </p>
        <p class="huifu">
          {{replyContent}}
        </p>
      </mu-content-block>
    </mu-popup>
    <XR-toast ref="XRtoast"></XR-toast>
	<XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loaded: true,
      dialog : false,
      Popup : false,
      searchInfo:{
        pageIndex:1,
        pageSize:20
      },
      dataList:[],
      replyContent:''
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getPage()
  },
  methods:{    
    goTo:function(url){
      this.$router.push(url)
    },    
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
      
    openPopup (msg) {
      this.replyContent = msg
      this.Popup = true
    },
    closePopup () {
      this.Popup = false
    },
    getPage:function(){
      var ths = this      
      ths.$post(
        "/Shop/UserServer/GetComplaintsAndSuggestionsPage",
        JSON.stringify(this.searchInfo)
      ).then(function(res) {
        ths.loaded = false
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
		  ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }else{      
          ths.dataList = res.Data.List
          ths.$refs.XRtoast.hide()
		  ths.$refs.XRPageTip.initTip()
        }
      });
    }
  }
}
</script>

<style>
#app .pageComplaintsSuggestions{
  background: white;
}
.pageComplaintsSuggestions .mu-item-after{
  color:#ccc;
}
.pageComplaintsSuggestions .mu-list{
  border-bottom: 1px solid #f5f5f5;
}
.pageComplaintsSuggestions .btn-cs-add{
  position: fixed;
  bottom: 60px;
  right: 20px;
}


.pageComplaintsSuggestions-popup{
  width: 100%;
}
.pageComplaintsSuggestions-popup .title{
  font-size: 16px;
  text-align: center;
}
.pageComplaintsSuggestions-popup .withdrawResult{
  font-size: 14px;
  text-align: center;
  padding-top: 20px;
}
.pageComplaintsSuggestions .mu-list .mu-item-content{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/ComplaintsSuggestions.vue